module.exports = __webpack_public_path__ + "img/profiles.5296a639.png";